import styled from 'styled-components';

type Props = {
  text: string | number;
};

const Badge = ({ text }: Props) => {
  return <StyledBadge>{text}</StyledBadge>;
};

export default Badge;

const StyledBadge = styled.div`
  position: absolute;
  right: 5px;
  background: ${({ theme }) => theme.colors.primaryColor};
  color: ${({ theme }) => theme.colors.textColor};
  font-size: 12px;
  text-align: center;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.textColor};
`;
